module.exports = __webpack_public_path__ + "img/Automation.8b30cb20.png";